const DROPDOWN_MENU_OPEN_EVENT = "chalk:dropdown-menu-open";

interface DropdownMenuOpenEventDetail {
  id: string;
}

export const announceDropdownMenuOpen = (id: string): void => {
  document.dispatchEvent(
    new CustomEvent<DropdownMenuOpenEventDetail>(DROPDOWN_MENU_OPEN_EVENT, {
      detail: { id },
    }),
  );
};

export const subscribeToOtherDropdownMenuOpen = (
  id: string,
  onOtherDropdownMenuOpen: () => void,
): (() => void) => {
  const handleDropdownMenuOpen = (event: Event) => {
    if (
      event instanceof CustomEvent &&
      (event as CustomEvent<DropdownMenuOpenEventDetail>).detail.id !== id
    ) {
      onOtherDropdownMenuOpen();
    }
  };

  document.addEventListener(DROPDOWN_MENU_OPEN_EVENT, handleDropdownMenuOpen);
  return () => document.removeEventListener(DROPDOWN_MENU_OPEN_EVENT, handleDropdownMenuOpen);
};
